import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';
import { supplier } from '../../utils/navigations';

const SupplierApprove = () => {
    const [requests, setRequests] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [isBannerVisible, setIsBannerVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [currentRequest,setCurrentRequest] = useState(null);
    const [currentSupplier,setCurrentSupplier] = useState(null);
    const [showBillUpload,setShowBillUpload] = useState(false)
    const [currentBill,setCurrentBill] = useState(null)
    const [message,setMessage] = useState('')
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        async function startup() {
            if (!user) {
                await authenticate(setUser, navigate);
            }
            if (user) {
                fetchRequests();
            }
        }
        startup();
    }, [user, successMessage]);

    const fetchRequests = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getRequests`, { withCredentials: true });
            const requestsWithIndex = Array.isArray(response?.data?.data)
                ? response.data.data
                .map((request, index) => ({ ...request, originalIndex: index }))
                .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)):[];
                setRequests(requestsWithIndex);
            console.log(requestsWithIndex);
        } catch(err) {
            const errorMessage = displayError(err,navigate,setUser);
            console.log(errorMessage);
              if(errorMessage){
                setMessage(errorMessage)
              }
          }
    };

    const handleCheckboxChange = (requestId, item, isChecked) => {
        setCheckedItems(prevState => {
            const newCheckedItems = { ...prevState };
            const key = `${requestId}-${item._id}`;
            if (isChecked) {
                newCheckedItems[key] = {
                    requestId: requestId,
                    itemId: item.item._id,
                    name: item.item.name,
                    quantity: item.quantity,
                };
            } else {
                delete newCheckedItems[key];
            }
            return newCheckedItems;
        });
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredRequests = requests.filter((request) =>
        `REQ00${request.requestNumber}`.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const checkedItemsCount = Object.keys(checkedItems).length;

    useEffect(() => {
        if (checkedItemsCount > 0) {
            setIsBannerVisible(true);
        } else {
            const timeoutId = setTimeout(() => {
                setIsBannerVisible(false);
            }, 300);
            return () => clearTimeout(timeoutId);
        }
    }, [checkedItemsCount, successMessage]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    };

    const addAndUpdate = () => {
        const updateStatus = Object.values(checkedItems).map(item => ({
            requestId: item.requestId,
            itemId: item.itemId
        }));

        const updateRequestStatus = axios.put(
            `${process.env.REACT_APP_API_URI}/api/supplier/approveItem`,
            { updateStatus },
            { withCredentials: true }
        );

        Promise.all([updateRequestStatus])
            .then(([updateRequestResponse]) => {
                setSuccessMessage('Items approved!');
                setCheckedItems(0);
                setErrorMessage('');
                setIsBannerVisible(false);
                setTimeout(() => {
                    navigate('/supplier/home');
                }, 1000);
            })
            .catch((error) => {
                setErrorMessage('An error occurred while processing your request. Please try again.');
                setSuccessMessage('');
                console.error(error);
            });
        fetchRequests();
    };

    const checkForBills = (request) => {
        axios.get(`${process.env.REACT_APP_API_URI}/api/bill/get?requestId=${request}&supplierName=${user.name}`,{withCredentials:true})
        .then((response) => {
            console.log(response);
            if(response.data.success){
                setCurrentBill(response.data.data)
            }
        })
        .catch((err) =>{
            setErrorMessage('An error occurred while processing your request. Please try again.');
            setSuccessMessage('');
            console.error(err);
        })
    }

    const submitData = (e) => {
        e.preventDefault();
        console.log(e.target.bill.files[0]);
        const finalObject = {
            bill:e.target.bill.files[0],
            request:currentRequest._id,
            supplier:user.name
        }
        if(currentBill==null){
            axios.post(`${process.env.REACT_APP_API_URI}/api/bill/add`, finalObject, { headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true })
                .then((response) => {
                    console.log(response.data);
                })
                .catch((error) => {
                    console.error(error);
                });
            // fetchRequests();
        }
        else {
            axios.put(`${process.env.REACT_APP_API_URI}/api/bill/update`, finalObject, { headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true })
                .then((response) => {
                    console.log(response.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        checkForBills(currentRequest._id);
    };


    const showUpload = async (request) => {
     checkForBills(request._id);
        setCurrentRequest(request);
        setShowBillUpload(true);
        document.body.style.overflow = 'hidden'; // Disable scrolling
      };
    
      const closeModals = () => {
        setShowBillUpload(false);
        document.body.style.overflow = 'auto'; // Enable scrolling
        setCurrentBill(null)
      };

    const BillUploadCard = () => (
        <>
          <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow dark:bg-gray-700 max-w-2xl w-full mx-3">
              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Bill Upload
                </h3>
                <button onClick={closeModals} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                  <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="p-4 md:p-5 space-y-4">
                <div>
                    {currentBill?
                     <>
                     <h4>Bill Uploaded</h4>
                     <img src={currentBill.file}></img>
                     </>
                     :
                     null
                    }
                </div>
                <form onSubmit={submitData}>
                <input
                type="file"
                name='bill'
                className="flex w-full justify-center rounded-full text-white bg-fmb-light px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                accept=".jpg,jpeg,.png,.doc,.docx,.pdf"
                />
                <button
                  type="submit"
                  className={`flex w-full mt-4 justify-center rounded-full
                   text-white bg-fmb px-3 py-3 text-sm font-semibold 
                   leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline 
                   focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                >
                  UPLOAD BILL
                </button>
                </form>
              </div>
              <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                <button onClick={closeModals} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">OK</button>
                <button onClick={closeModals} className="py-2.5 px-5 ml-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">Close</button>
              </div>
            </div>
          </div>
        </>
      );

    const getStatusColor = (status) => {
        switch (status) {
            case 'supplyrequested':
                return 'bg-orange-100 text-orange-700';
            case 'pending':
                return 'bg-red-100 text-red-700';
            case 'supplyapproved':
                return 'bg-green-100 text-green-700';
            case 'dispatched':
                return 'bg-blue-100 text-blue-700';
            case 'received':
                return 'bg-green-100 text-green-700';
            default:
                return 'bg-blue-100 text-blue-700';
        }
    };

    const renderRequestItems = (request) => {
        const itemsToRender = request.items.map((item, idx) => (
            <div key={item._id} className={`relative flex items-center pb-4 mb-2 ${idx < request.items.length - 1 ? 'border-b pb-2' : ''}`}>
                <label className="custom-checkbox flex-shrink-0">
                    <input
                        type="checkbox"
                        disabled={item.status !== 'supplyrequested'}
                        checked={checkedItems[`${request._id}-${item._id}`] !== undefined}
                        onChange={(e) => handleCheckboxChange(request._id, item, e.target.checked)}
                    />
                    <span className="checkmark"></span>
                </label>
                <div className="flex-grow ml-2">
                    <h3 className="text-[15px] text-fmb font-semibold">{item.item.name}</h3>
                    <p className="text-sm text-gray-600">{item.item.category}</p>
                    
                </div>
                <div className="ml-4 text-center">
                    <p className="text-lg -mt-3 text-gray-600 font-semibold">{item.quantity} {item.item.unit}</p>
                </div>
                <div className={`absolute bottom-1 -end-4 text-xs px-2 py-1 mt-1 rounded-l-lg font-semibold ${getStatusColor(item.status)}`}>
                    {item.status}
                </div>
            </div>
        ));
        
        return (
            <div>
                <div className='flex justify-between mb-2'>
                    <div>
                    <span className="text-lime-700 text-sm font-semibold">Zone : {request.items[0].zone?.desc}</span>
                    <p className="text-lime-700 text-sm font-normal">{request.items[0].zone?.address}</p>
                    </div>
                    <div>
                    <button onClick={() => showUpload(request)}
                        className="bg-fmb text-white py-2 px-3 rounded text-xs font-normal hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50">
                            Upload Bill
                    </button>
                    </div>
                </div>
                {itemsToRender}
            </div>
        );
    };

    return (
        <div className="p-4 pb-20">
            <input
                type="text"
                placeholder="Search requests..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="mb-4 p-2 border border-gray-300 rounded w-full"
            />
            {filteredRequests.length > 0 ? (
                filteredRequests.map((request) => {
                    const approvedItems = request.items.filter(item => item.status === 'supplyapproved');
                    return (
                        <div key={request._id} className="bg-white p-4 mb-3 border rounded shadow-md relative">
                            <div className="flex justify-between items-center mb-2">
                                <h2 className="text-[16px] font-semibold text-gray-700">
                                    REQ00{request.requestNumber}
                                </h2>
                                <h4 className="text-sm text-gray-400">{formatDate(request.date)}</h4>
                            </div>
                            {renderRequestItems(request)}
                            {approvedItems.length > 0 && (
                                <div className="mt-4 flex justify-end">
                                    <button 
                                        onClick={(e) => navigate("/supplier/dispatch", { state: { request,approvedItems } })}
                                        className="bg-green-600 text-sm text-white py-2 px-3 rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-50"
                                    >
                                        Dispatch
                                    </button>
                                </div>
                            )}
                        </div>
                    );
                })
            ) : (
                <p className="text-gray-600">No requests found.</p>
            )}

            {isBannerVisible && (
                <div className={`fixed bottom-0 pb-20 left-0 right-0 p-4 bg-yellow-100 shadow-lg ${checkedItemsCount > 0 ? 'animate-slideIn' : 'animate-slideOut'}`}>
                    {successMessage && <div style={{ color: 'green' }}>{successMessage}</div>}
                    {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
                    <div className='flex justify-between items-center'>
                        <span className="text-[14px] font-semibold">{checkedItemsCount} items selected</span>
                        <button className="text-[15px] bg-fmb text-white px-4 py-2 rounded font-medium" onClick={addAndUpdate}>Approve Items</button>
                    </div>
                </div>
            )}
            
          {showBillUpload && <BillUploadCard />}
        </div>
    );
};

export default SupplierApprove;
